import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, addAuthorizeHeader, getCookie } from '../../utils'

export const songActionTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'SET_KEY'], 'SONGDATA');
export const songFlagActionTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR'], 'SONGFLAG');


export const requestSong = () => {
    return {
        type: songActionTypes.REQUEST,
    };
};

export const receiveSong = (response, key) => {
    return {
        type: songActionTypes.RECEIVE,
        data: response,
    };
};

export const receiveSongError = () => {
    return {
        type: songActionTypes.ERROR,
    };
};

export const setKey = (id, key) => {
    return dispatch => {
        dispatch(fetchSong(id, key))
    }
}

export const fetchSong = (id, key='', instrument='') => {
    return dispatch => {

        dispatch(requestSong());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        let url = `/api/v3/core/songs/${id}/`

        if (key !== '' && key !== null) {
            if (key.includes('#')) {
                key = key.replace('#', 'sharp')
            }
            url = `${url}transpose/?key=${key}`
        }

        if (instrument !== '') {
            if (url.includes('transpose')) {
                url = `${url}&instrument=${instrument}`
            } else {
                url = `${url}transpose/?instrument=${instrument}`
            }
        }

        return fetch(url, {
            headers: headers
        })
        .then(parseJSON)
        .then(response => {

            try {
                dispatch(receiveSong(response, key));
            } catch (e) {
                dispatch(receiveSongError(response))
            }


        })
        .catch(handleNetworkError);
    };
};

export const requestSongFlag = () => {
    return {
        type: songFlagActionTypes.REQUEST,
    };
};

export const receiveSongFlag = (response) => {
    return {
        type: songFlagActionTypes.RECEIVE,
        data: response,
    };
};

export const receiveSongFlagError = (response) => {
    return {
        type: songFlagActionTypes.ERROR,
        data: response,
    };
};

export const flagSong = (id, data) => {
    return dispatch => {
        dispatch(requestSongFlag());

        let headers = addAuthorizeHeader({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("guitarpartycsrftoken"),
            credentials: 'include'
        })

        return fetch(`/api/v3/core/songs/${id}/flag/`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(response => {
            if (!response.ok) {
                return Promise.resolve(parseJSON(response)).then(error => Promise.reject({
                    data: error,
                    isHttpError: true,
                    status: response.status,
                }));
            }
            return response;
        })
        .then(parseJSON)
        .then(response => {
            dispatch(receiveSongFlag(response))
            return response
        })
        .catch(response => {
            dispatch(receiveSongFlagError(response.data || response))
            if (!response || !response.isHttpError) {
                handleNetworkError(response)
            }
            throw response
        });
    };
};
